<template>
   <body style="margin:0; padding:0; background:#f6f6f6;">
    <!-- 預覽文字（preheader） -->
    <div style="display:none; max-height:0; overflow:hidden; opacity:0; color:transparent;">
      Before the year wraps up, here’s a small note to say thank you…
    </div>

    <!-- 外層背景 -->
    <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background:#f6f6f6;">
      <tr>
        <td align="center" style="padding:24px 16px 48px;">
          <!-- 卡片容器 -->
          <table role="presentation" width="720" cellspacing="0" cellpadding="0" border="0"
            style="width:100%; max-width:720px; background:#ffffff; border:1px solid #e5e7eb; border-radius:16px; overflow:hidden;">
            
            <!-- HERO -->
            <tr>
              <td style="padding:0; margin:0;">
                <img
                  src="https://www.union.com.tw/img/2026-NewYear-EDM.jpg"
                  alt="Holiday Hero"
                  width="720"
                  style="display:block; width:100%; height:auto; border:0; margin:0; padding:0;"
                />
              </td>
            </tr>

            <!-- CONTENT -->
            <tr>
              <td class="content-pad" style="padding:28px 22px; color:#1f2937; font-family:system-ui,-apple-system,'Segoe UI',Roboto,'Noto Sans TC',Arial,sans-serif; line-height:1.7;">
                
                <h1 style="margin:0 0 10px; font-size:26px; font-weight:700; letter-spacing:0.2px; line-height:1.25;">
                  Wishing You a Restful and Bright Holiday Season
                </h1>

                <p style="margin:0 0 14px; color:#6b7280;">
                  Before the year wraps up, here’s a small note to say thank you. You’ve
                  shown up for your students, your colleagues, and your community in
                  countless ways, and it’s made a real difference. We’re glad to be part
                  of your year.
                </p>

                <p style="margin:0 0 14px; color:#6b7280;">
                  To close the season on a lighter note, we’re sharing two treats with you:
                </p>

                <h1 style="margin:0 0 10px; font-size:26px; font-weight:700; letter-spacing:0.2px; line-height:1.25;">
                  Wishing You a Restful and Bright Holiday Season
                </h1>

                <p style="margin:0 0 14px; color:#6b7280;">
                  Before the year wraps up, here’s a small note to say thank you. You’ve
                  shown up for your students, your colleagues, and your community in
                  countless ways, and it’s made a real difference. We’re glad to be part
                  of your year.
                </p>

                <p style="margin:0 0 14px; color:#6b7280;">
                  To close the season on a lighter note, we’re sharing two treats with you:
                </p>

                <!-- list item 1 -->
                <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="margin:14px 0 10px;">
                  <tr>
                    <td style="background:#fafafa; border:1px solid #e5e7eb; border-radius:12px; padding:12px;">
                      <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
                        <tr>
                          <td width="24" valign="top" style="width:24px; padding-right:10px; font-size:16px; line-height:1.4;">
                            🍬
                          </td>
                          <td valign="top" style="color:#1f2937; font-size:16px;">
                            <b style="font-weight:700;">New Year giveaway</b> 到
                            <a href="https://www.facebook.com/Union.Ocean.Co.Ltd?locale=zh_TW"
                               target="_blank"
                               style="color:#00489b; text-decoration:underline;">
                              Facebook
                            </a>
                            留言解謎，就有機會獲得小禮物。
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>

                <!-- list item 2 -->
                <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="margin:0 0 18px;">
                  <tr>
                    <td style="background:#fafafa; border:1px solid #e5e7eb; border-radius:12px; padding:12px;">
                      <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
                        <tr>
                          <td width="24" valign="top" style="width:24px; padding-right:10px; font-size:16px; line-height:1.4;">
                            🖋️
                          </td>
                          <td valign="top" style="color:#1f2937; font-size:16px;">
                            <b style="font-weight:700;">2026 Monthly Planner</b> 可在任何支援 PDF 的裝置使用，點下面圖片下載。
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>

                <!-- DOWNLOAD divider -->
                <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="border-top:1px solid #e5e7eb; margin-top:18px;">
                  <tr>
                    <td style="padding-top:18px;">
                      <a href="https://www.union.com.tw/img/2026-MonthlyPlanner.jpg"
                         target="_blank"
                         style="text-decoration:none; color:inherit;">
                        <img
                          src="https://www.union.com.tw/img/2026-MonthlyPlanner.jpg"
                          alt="Download Monthly Planner"
                          width="676"
                          style="display:block; width:100%; height:auto; border:1px solid #e5e7eb; border-radius:14px;"
                        />
                      </a>
                    </td>
                  </tr>
                </table>

                <p style="margin:18px 0 0; color:#1f2937;">
                  Thank you for sharing your time and support with us this year. Wishing
                  you a calm holiday break and a fresh start.
                </p>
              </td>
            </tr>

            <!-- FOOTER -->
            <tr>
              <!-- 漸層在 Outlook 容易不吃：用穩定的實色底 -->
              <td align="center" style="background:#00489b; padding:20px 16px 22px; color:#ffffff; font-family:system-ui,-apple-system,'Segoe UI',Roboto,'Noto Sans TC',Arial,sans-serif;">
                
                <!-- social -->
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin:0 auto 10px;">
                  <tr>
                    <td style="padding:0 11px;">
                      <a href="https://www.facebook.com/Union.Ocean.Co.Ltd?locale=zh_TW"
                         target="_blank"
                         aria-label="Facebook"
                         style="color:#ffffff; text-decoration:none; font-size:16px; opacity:0.95;">
                        <img style="color:#ffffff; text-decoration:none; width: 25px; opacity:0.95;" src="https://www.union.com.tw/img/FB.png" alt="">
                      </a>
                    </td>
                    <td style="padding:0 11px;">
                      <a href="https://www.youtube.com/@union.youtube1945"
                         target="_blank"
                         aria-label="YouTube"
                         style="color:#ffffff; text-decoration:none; font-size:16px; opacity:0.95;">
                        <img style="color:#ffffff; text-decoration:none; width: 25px; opacity:0.95;" src="https://www.union.com.tw/img/YT.png" alt="YouTube">
                      </a>
                    </td>
                  </tr>
                </table>

                <!-- contact -->
                <div class="contact" style="font-size:14px; line-height:1.6; letter-spacing:0.2px; color:#ffffff;">
                  <span class="contact-wrap">
                    <a href="mailto:cs@union.com.tw" style="color:#ffffff; text-decoration:none; font-weight:500;">cs@union.com.tw</a>
                    <span class="sep" style="color:rgba(255,255,255,0.6); margin:0 8px;">|</span>
                    <a href="tel:+886423292669" style="color:#ffffff; text-decoration:none; font-weight:500;">+886 42329 2669</a>
                    <span class="sep" style="color:rgba(255,255,255,0.6); margin:0 8px;">|</span>
                    <a href="https://www.union.com.tw/" target="_blank" style="color:#ffffff; text-decoration:none; font-weight:500;">Union Ocean</a>
                  </span>
                </div>

              </td>
            </tr>

          </table>
        </td>
      </tr>
    </table>
  </body>
</template>

<style scoped>
      @media screen and (max-width: 420px) {
        .content-pad { padding: 22px 16px !important; }
        .contact { font-size: 13px !important; }
        .contact-wrap { display: block !important; }
        .sep { display: none !important; }
        .contact a { display: inline-block !important; margin: 0 6px 6px !important; }
      }
</style>
